import Moment from "moment";
import React, { useMemo } from "react";
import { Card, Form } from "react-bootstrap";
import FormField from "components/FormField";
import { createElementIdFactory } from "utils/elementIds";

/**
 * RecordHistoryTab
 *
 * Pure display component. Shows created/edited metadata for the sale record.
 * No state, no save — receives everything as props.
 *
 * Props:
 *   createdDate    - ISO date string or null
 *   createdBy      - string or null
 *   lastEditedDate - ISO date string or null
 *   lastEditedBy   - string or null
 */
function RecordHistoryTab({ createdDate, createdBy, lastEditedDate, lastEditedBy }) {
  const createId = useMemo(() => createElementIdFactory("sale-detail-record-history"), []);

  function formatDate(d) {
    return d && Moment(d).isValid() ? Moment(d).local().format("DD-MM-YYYY") : "";
  }

  return (
    <Card id={createId("card")} style={{ width: "28rem" }}>
      <Card.Body>
        <FormField controlId={createId("created-date")} label="Created Date">
          <Form.Control value={formatDate(createdDate)} plaintext readOnly />
        </FormField>

        <FormField controlId={createId("created-by")} label="Created By">
          <Form.Control value={createdBy || ""} plaintext readOnly />
        </FormField>

        <FormField controlId={createId("last-edited-date")} label="Last Edited Date">
          <Form.Control value={formatDate(lastEditedDate)} plaintext readOnly />
        </FormField>

        <FormField controlId={createId("last-edited-by")} label="Last Edited By">
          <Form.Control value={lastEditedBy || ""} plaintext readOnly />
        </FormField>
      </Card.Body>
    </Card>
  );
}

export default RecordHistoryTab;
